<template>
  <div class="contract-progress">
    <div class="ms-help label">
      {{ getLabel() }}
    </div>
    <i-progress :stroke-width="12" :percent="getPercentile(part, all)" hide-info />
  </div>
</template>

<script>
export default {
  props: ['part', 'all', 'label'],
  methods: {
    getLabel () {
      return `${this.label}: ${this.getPercentile(this.part, this.all, true)}%`
    },
    getPercentile (part, full, noOverhead) {
      if (full === 0) return 0
      if (!noOverhead && part > full) return 100
      return Math.floor((part / full) * 100)
    }
  }
}
</script>

<style lang="less">
.contract-progress {
  flex: 1;
  display: flex;
  align-items: center;

  .ms-help {
    flex-shrink: 0;
    width: 96px;
    margin-right: 16px;

    &.label {
      margin-bottom: 0;
    }
  }
}
</style>
